import styled from 'styled-components';
import { darken, lighten } from 'polished';

interface TableContentProps {
  showHeader: boolean;
  rowIsClickable: boolean;
}

export const TableContent = styled.div<TableContentProps>`
  border-radius: 20px;
  /* overflow: hidden; */
  background-color: #202020;
  z-index: 0;

  h2 {
    color: #cbccce;
  }

  .height {
    height: 20px;
  }

  .border-gray {
    border: solid 1px #333;
  }

  .menu-table {
    z-index: 100;
    top: 15px;
    left: 15px;
    right: 15px;

    .search {
      padding: 1px;
      border-radius: 100px;

      div {
        background: #202020;
        border-radius: 100px;
      }

      input {
        margin: 5px 0;
        padding: 0 10px;
        border: none;
        border-radius: 100px;
        background-color: #202020;
        color: #fdfdfd;
      }
    }

    .inputDate {
      border: 1px solid #333333;
      background: #202020;
      color: #828282;
      padding: 5px 10px;
      border-radius: 100px;
      :hover {
        color: ${lighten(0.1, '#828282')};
        border: 1px solid ${lighten(0.1, '#333')};
        transition-duration: 0.5s;
        img {
          filter: brightness(1.5);
          transition-duration: 0.5s;
        }
      }
    }
  }

  div.tableData {
    .rdt_TableHeader {
      display: ${(props) => (props.showHeader ? 'block' : 'none')};
    }

    div {
      background-color: #202020;
    }

    .rdt_TableRow {
      padding: 5px 0;
      cursor: ${(props) => (props.rowIsClickable ? 'pointer' : 'default')};
      transition-duration: 0.3s;
      min-width: 1000px;

      div {
        transition-duration: 0.3s;
      }

      :hover {
        background-color: ${darken(0.03, '#1D2023')};

        div {
          background-color: ${darken(0.03, '#1D2023')};
        }
      }
    }
  }

  @media screen and (max-width: 1399px) {
    div.tableData {
      max-width: 1200px;
    }
  }

  @media screen and (max-width: 991px) {
    .react-datepicker-wrapper {
      width: 100%;
    }
  }

  @media screen and (max-width: 355px) {
    .size-xxs {
      font-size: 12px;
      padding: 8px 10px !important;
    }

    .svg-xxs {
      img {
        width: 16px !important;
      }
    }
  }

  @media screen and (min-width: 575px) {
    .w-100px {
      width: 100px;
    }
  }
`;

export const Pagination = styled.div`
  p,
  button {
    color: #8c8c8c;
  }

  button {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-weight: bold;

    :first-child,
    :last-child {
      width: auto;
      border-radius: 5px;
    }
  }

  button.active,
  button:hover:not(:disabled) {
    background: linear-gradient(
      269.95deg,
      rgba(96, 96, 96, 0.5) 0.02%,
      rgba(96, 96, 96, 0.5) 97.45%
    );
    color: #fff;
  }

  @media screen and (max-width: 991px) {
    .btn-page:not(.active) {
      display: none;
    }
  }
`;

export const NotFound = styled.div`
  display: flex;
  width: 100% !important;
  height: 350px;
  justify-content: center;
  align-items: center;
  color: #8d8d8d;
`;
